module.exports = __webpack_public_path__ + "static/img/modal_desc.4829b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor9/modal_desc.png
// module id = 1q0V
// module chunks = 2